import Repository from "../repository";

const endPoint = 'patient';

export default class Patient extends Repository {
    constructor(dataSource) {
        super(dataSource, endPoint);
    }

    login(credentials) {
        return this.dataSource.post(`login`, credentials)
            .then(({data}) => data)
    }

    register(form) {
        return this.dataSource.post('sign-up', this.filterNull({...form})).then(({data}) => data)
    }

    update(form) {
        return this.dataSource.post('update', this.filterNull({...form})).then(({data}) => data)
    }

    updateERProfile(form) {
        return this.dataSource.post('update-er-profile', this.filterNull({...form})).then(({data}) => data);
    }

    updateSubAccount(form) {
        return this.dataSource.post('update-sub-account', this.filterNull({...form})).then(({data}) => data);
    }

    resetPassword(form) {
        return this.dataSource.post('reset-password', form).then(({data}) => data);
    }

    getUser() {
        return this.dataSource.get('').then(({data: {data}}) => data)
    }
}
